import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { decode, relativizeURL } from 'lib/Utils'
import $ from 'jquery'

// Components
import BtnText from 'components/BtnText'
import { Link } from 'react-router'

// Assets
import ArrowLeft from 'assets/images/arrow-left-bronze.svg'
import ArrowRight from 'assets/images/arrow-right-bronze.svg'

// Styles
import './index.scss'

class ServicesNavMobile extends Component {
  constructor (props) {
    super(props)
    const serviceTitle = (this.props.selectedService && this.props.services) ? this.getServiceTitle(this.props.selectedService) : null
    this.state = { serviceTitle, direction: 1 }
  }

  getCurrentServiceIndex () {
    return this.getServiceIndex(this.props.selectedService)
  }

  getServiceIndex (serviceID) {
    return this.props.services.findIndex((service) => { return service.ID === serviceID })
  }

  hasServiceRelatedProps (props = this.props) {
    return (props.services !== null && props.services.length > 0 && props.selectedService !== null)
  }

  getServiceTitle (serviceID) {
    const selectedServiceObj = this.props.services.find((service) => { return service.ID === serviceID })
    let toReturn = null
    if (selectedServiceObj) {
      toReturn = selectedServiceObj.title
    }

    return toReturn
  }

  getAdjacentService (next = true) {
    if (this.hasServiceRelatedProps()) {
      const serviceIndex = this.getCurrentServiceIndex()
      if (next) {
        if (serviceIndex === this.props.services.length - 1) {
          return this.props.services[0]
        } else {
          return this.props.services[serviceIndex + 1]
        }
      } else {
        if (serviceIndex === 0) {
          return this.props.services[this.props.services.length - 1]
        } else {
          return this.props.services[serviceIndex - 1]
        }
      }
    } else {
      return null
    }
  }

  render () {
    const prevService = this.getAdjacentService(false)
    const nextService = this.getAdjacentService(true)
    if (!prevService || !nextService) return null

    return (
      <div ref={(el) => { this.component = el }} className='services-nav-mobile'>
        <ul className='list-unstyled'>
          <li>
            <Link to={prevService.url}>
              <div className='counter'>{(this.getServiceIndex(prevService.ID) + 1).toString().padStart(2, 0)}</div>
              <div className='title'>{decode(prevService.title)}</div>
              <BtnText className='btn-text--lined'>Read More</BtnText>
              <img src={ArrowLeft} alt='Previous' />
            </Link>
          </li>
          <li>
            <Link to={nextService.url}>
              <div className='counter'>{(this.getServiceIndex(nextService.ID) + 1).toString().padStart(2, 0)}</div>
              <div className='title'>{decode(nextService.title)}</div>
              <BtnText className='btn-text--lined'>Read More</BtnText>
              <img src={ArrowRight} alt='Next' />
            </Link>
          </li>
        </ul>
      </div>
    )
  }
}

ServicesNavMobile.propTypes = {
  services: PropTypes.array,
  selectedService: PropTypes.number
}

export default ServicesNavMobile



// WEBPACK FOOTER //
// ./src/components/ServicesNavMobile/index.js